(function($){
 $(function($){

    var destinList;

 	$('.destin-list').imagesLoaded().done(function(){
		destinList = $('.destin-list').isotope({
                        layoutMode: 'fitRows',
                        //layoutMode: 'packery',
                        // stamp elements
			//stamp: '.stamp', 
			// specify itemSelector so stamps do get laid out
			itemSelector: '.grid-item',
                        /*packery: {
                            // packery options
                            isHorizontal: true
                        },*/
			getSortData: {
				name: '[data-title]', 
				views: '[data-views] parseInt'
			},
			sortBy: 'name' 
		});
	}); 


	$('#destin-sort #alphabetic-sort').on('click', function(){ 
		destinList.isotope({ sortBy : 'name', sortAscending: true});
	}); 

	$('#destin-sort #popular-sort').on('click', function(){
                $('.stamp-banner').css({'position':'absolute'});
		destinList.isotope({ sortBy : 'views', sortAscending: false});
	});

	$( document.body ).on( 'post-load', function(){
		destinList.isotope();
	}); 

 }); 
})(jQuery);